.card {
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
}

.event {
  color: var(--comp-calendarevent-color);
  display: flex !important;
  height: 100%;
  position: relative;
}

.description {
  -webkit-box-orient: vertical;

  /* Don't work in some cases */
  display: -webkit-box;
  font-size: var(--font-size-8);
  -webkit-line-clamp: 3;
  line-height: var(--line-size-8);
  overflow: hidden;
  text-overflow: ellipsis;
}

.insideScrollable.event {
  min-width: 300px;
  min-width: max(300px, calc(33.33% - 2 * var(--space-medium)));
}

.insideScrollable .description {
  -webkit-box-orient: none;

  /* Don't work in the slider */
  display: block;
  -webkit-line-clamp: none;
}

.date {
  align-content: center;
  align-items: center;
  background:#000;
  color: var(--theme-white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 60px;
  width: 60px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--space-small);
  justify-content: space-between;
  padding: var(--space-medium);
  position: relative;
  width: calc(100% - 60px - 2 * var(--space-medium));
}

.head {
  display: flex;
  gap: var(--space-medium);
  justify-content: space-between;
}

.title {
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%
}

.logoLink {
  height: 30px;
  min-width: 30px;
  position: relative;
}

.logo {
  border-radius: var(--border-radius-small);
  height: 100%;
  object-fit: contain;
  width: 100%;
}

.deadline {
  font-size: var(--font-size-8);
  font-weight: 600;
  line-height: var(--line-size-8);
  margin-bottom: var(--space-tiny);
}

.deadline time {
  font-weight: 400;
}

.dateDate {
  font-size: var(--font-size-2);
  font-weight: bold;
  line-height: 1em;
  line-height: var(--line-size-2);
  margin-bottom: var(--space-small);
}

.ended {
  opacity: 0.45;
}

.dateMonth {
  font-size: var(--font-size-8);
  line-height: var(--line-size-8);
  text-transform: uppercase;
}

.dateYear {
  font-size: var(--font-size-8);
  letter-spacing: 0.1em;
  line-height: var(--line-size-8);
}
